export function SkeletonRow({
  widths = ['70%', '40%', '50%']
}: {
  widths?: ReadonlyArray<string>;
}): JSX.Element {
  return (
    <div
      className="px-3.5 py-3 border-b border-border"
      role="status"
      aria-label="Loading"
    >
      {widths.map((w, i) => (
        <div

          key={i}
          className="h-3 bg-panel-2 rounded mb-1.5 animate-skel"
          style={{ width: w }}
        />
      ))}
    </div>
  );
}

export function SkeletonGridRow({ cols }: { cols: number }): JSX.Element {
  return (
    <div
      className="px-4 py-2.5 border-b border-border grid gap-3.5"
      style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
      role="status"
      aria-label="Loading"
    >
      {Array.from({ length: cols }, (_, i) => (

        <div key={i} className="h-3 bg-panel-2 rounded animate-skel" />
      ))}
    </div>
  );
}
